<template>
  <div class="wrapper">
    <div class="title">Conversion Rate (Actual %)</div>
    <div id="ConversionRatesChart"></div>
  </div>
</template>

<script>
const am4core = require("@amcharts/amcharts4/core");
const am4charts = require("@amcharts/amcharts4/charts");
const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
const timezone = require("dayjs/plugin/timezone");
const customParseFormat = require("dayjs/plugin/customParseFormat");
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
import am4themes_material from "@amcharts/amcharts4/themes/material";

export default {
  components: {},
  props: {
    stats: {
      type: Object,
      required: true,
    },
    customers: {
      type: Array,
      required: true,
    },
    mode: {
      type: String,
      required: false,
      default: "today",
    },
    selectedDate: {
      type: Date,
      required: true,
    },
  },
  data: function () {
    return {
      chart: {},
      chartData: [],
      currentTimezone: dayjs.tz.guess(),
      formattedSelectedDate: dayjs(this.selectedDate),
    };
  },
  methods: {
    InitChart: async function () {
      am4core.useTheme(am4themes_material);
      let chart = am4core.create("ConversionRatesChart", am4charts.XYChart);
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "date";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      for (const [key, dateData] of Object.entries(this.stats)) {
        const Obj = {};
        let dateObj = new Date(key);
        Obj.date =
          dateObj.getDate() + "/" + this.appendLeadingZeroes(dateObj.getMonth() + 1) + " " + this.appendLeadingZeroes(dateObj.getHours()) + ":" + this.appendLeadingZeroes(dateObj.getMinutes());
        let totalCalls = 0;
        let totalBooked = 0;
        for (const [customerId, customerData] of Object.entries(dateData)) {
          for (const [outcome, amount] of Object.entries(customerData)) {
            if (outcome == "Booked" || outcome == "booked") {
              totalBooked += amount;
            }
            totalCalls += amount;
          }
          Obj.conversionRate = ((totalBooked / totalCalls) * 100).toFixed();
        }
        this.chartData.push(Obj);
      }
      chart.data = this.chartData;
      const series = new am4charts.LineSeries();
      series.dataFields.valueY = "conversionRate";
      series.dataFields.categoryX = "date";
      series.tooltipText = "{valueY}%";
      chart.series.push(series);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 10;
    },
    Today: async function () {
      am4core.useTheme(am4themes_material);
      this.chart = am4core.create("ConversionRatesChart", am4charts.XYChart);
      let chart = this.chart;
      chart.legend = new am4charts.Legend();
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "time";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      let today = this.stats[this.formattedSelectedDate.format("DD-MM-YYYY")];
      let todaysDate = this.formattedSelectedDate.format("DD-MM-YYYY");
      let lastWeek = this.stats[dayjs(this.selectedDate).subtract(7, "day").format("DD-MM-YYYY")];
      const dataObj = {};
      for (const [key, timeData] of Object.entries(today)) {
        let date = dayjs(`${todaysDate} ${key}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[key]) {
          dataObj[key] = {
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }

        for (const [customerId, customerData] of Object.entries(timeData)) {
          if (this.customers[customerId] === undefined || this.customers[customerId].type == "dev" || this.customers[customerId].type == "demo") {
            continue;
          }
          if (customerData.bookableSessions == 0) continue;
          for (const [outcome, amount] of Object.entries(customerData)) {
            if (outcome == "Booked" || outcome == "booked") {
              if (!dataObj[key].todayBooked) dataObj[key].todayBooked = 0;
              dataObj[key].todayBooked += amount;
            }
            if (outcome == "fullybooked" || outcome == "fully_booked") {
              if (!dataObj[key].todayFullyBooked) dataObj[key].todayFullyBooked = 0;
              dataObj[key].todayFullyBooked += amount;
            }
            if (!dataObj[key].todayCalls) dataObj[key].todayCalls = 0;
            if (outcome.toLowerCase() == "bookablesessions") dataObj[key].todayCalls += amount;
          }
          if (dataObj[key].todayCalls && dataObj[key].todayBooked) {
            dataObj[key].todayConversionRate = ((dataObj[key].todayBooked / dataObj[key].todayCalls) * 100).toFixed();
          }
        }
      }
      for (const [key, timeData] of Object.entries(lastWeek)) {
        let date = dayjs(`${todaysDate} ${key}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[key]) {
          dataObj[key] = {
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }

        for (const [customerId, customerData] of Object.entries(timeData)) {
          if (this.customers[customerId] === undefined || this.customers[customerId].type == "dev" || this.customers[customerId].type == "demo") {
            continue;
          }
          for (const [outcome, amount] of Object.entries(customerData)) {
            if (outcome == "Booked" || outcome == "booked") {
              if (!dataObj[key].lastWeekBooked) dataObj[key].lastWeekBooked = 0;
              dataObj[key].lastWeekBooked += amount;
            }
            if (outcome == "fullybooked" || outcome == "fully_booked") {
              if (!dataObj[key].lastWeekFullyBooked) dataObj[key].lastWeekFullyBooked = 0;
              dataObj[key].lastWeekFullyBooked += amount;
            }
            if (!dataObj[key].lastWeekCalls) dataObj[key].lastWeekCalls = 0;
            if (outcome.toLowerCase() == "bookablesessions") dataObj[key].lastWeekCalls += amount;
          }
          if (dataObj[key].lastWeekBooked && dataObj[key].lastWeekCalls) {
            dataObj[key].lastWeekConversionRate = ((dataObj[key].lastWeekBooked / dataObj[key].lastWeekCalls) * 100).toFixed();
          }
        }
      }
      for (const [key, value] of Object.entries(dataObj)) {
        this.chartData.push(value);
      }
      chart.data = this.chartData;
      let lastWeekSeries = new am4charts.LineSeries();
      lastWeekSeries.dataFields.valueY = `lastWeekConversionRate`;
      lastWeekSeries.dataFields.categoryX = "time";
      lastWeekSeries.stroke = am4core.color("grey");
      lastWeekSeries.strokeWidth = 4;
      lastWeekSeries.fill = am4core.color("grey");
      lastWeekSeries.tooltipText = `Last Week Conversion Rate: {lastWeekConversionRate}% ({lastWeekFullyBooked} fully booked)`;
      lastWeekSeries.tooltip.background.fill = am4core.color("grey");
      lastWeekSeries.propertyFields.stroke = am4core.color("grey");
      lastWeekSeries.propertyFields.fill = am4core.color("grey");
      lastWeekSeries.fillOpacity = 0.5;
      lastWeekSeries.name = `Last Week Conversion Rate`;
      chart.series.push(lastWeekSeries);

      let series = new am4charts.LineSeries();
      series.dataFields.valueY = `todayConversionRate`;
      series.dataFields.categoryX = "time";
      series.stroke = am4core.color("#47d061");
      series.strokeWidth = 4;
      series.fill = am4core.color("#47d061");
      series.tooltipText = `Conversion Rate: {todayConversionRate}% ({todayFullyBooked} fully booked)`;
      series.tooltip.background.fill = am4core.color("#47d061");
      series.name = `Today's Conversion Rate`;
      chart.series.push(series);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 20;
    },
    TodayAverage: async function () {
      am4core.useTheme(am4themes_material);
      let chart = am4core.create("ConversionRatesChart", am4charts.XYChart);
      chart.legend = new am4charts.Legend();
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "time";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      let today = this.stats[Object.keys(this.stats)[Object.keys(this.stats).length - 1]];
      let todaysDate = Object.keys(this.stats)[Object.keys(this.stats).length - 1];
      let lastWeek = this.stats[Object.keys(this.stats)[Object.keys(this.stats).length - 8]];
      const dataObj = {};
      for (const [key, timeData] of Object.entries(today)) {
        let date = dayjs(`${todaysDate} ${key}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[key]) {
          dataObj[key] = {
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }

        let conversionRate = 0;
        let numberOfCustomers = 0;
        let fullyBookedRate = 0;

        for (const [customerId, customerData] of Object.entries(timeData)) {
          if (this.customers[customerId] === undefined || this.customers[customerId].type == "dev" || this.customers[customerId].type == "demo") {
            continue;
          }
          if (customerData.bookableSessions == 0 || typeof customerData.Booked == "undefined") continue;
          conversionRate += (customerData.Booked / customerData.bookableSessions) * 100;
          if (typeof customerData.fullybooked !== "undefined") fullyBookedRate += (customerData.fullybooked / customerData.bookableSessions) * 100;
          numberOfCustomers++;
        }
        dataObj[key].todayConversionRate = (conversionRate / numberOfCustomers).toFixed(0);
        dataObj[key].todayFullyBooked = (fullyBookedRate / numberOfCustomers).toFixed(0);
      }
      for (const [key, timeData] of Object.entries(lastWeek)) {
        let date = dayjs(`${todaysDate} ${key}`, "DD-MM-YYYY HH:mm").utc(true);
        if (!dataObj[key]) {
          dataObj[key] = {
            time: dayjs.tz(date, this.currentTimezone).format("HH:mm"),
          };
        }

        let conversionRate = 0;
        let numberOfCustomers = 0;
        let fullyBookedRate = 0;

        for (const [customerId, customerData] of Object.entries(timeData)) {
          if (this.customers[customerId] === undefined || this.customers[customerId].type == "dev" || this.customers[customerId].type == "demo") {
            continue;
          }
          if (customerData.bookableSessions == 0 || typeof customerData.Booked == "undefined") continue;
          conversionRate += (customerData.Booked / customerData.bookableSessions) * 100;
          if (typeof customerData.fullybooked !== "undefined") fullyBookedRate += (customerData.fullybooked / customerData.bookableSessions) * 100;
          numberOfCustomers++;
        }
        dataObj[key].lastWeekConversionRate = (conversionRate / numberOfCustomers).toFixed(0);
        dataObj[key].lastWeekFullyBooked = (fullyBookedRate / numberOfCustomers).toFixed(0);
      }
      for (const [key, value] of Object.entries(dataObj)) {
        this.chartData.push(value);
      }
      chart.data = this.chartData;
      let lastWeekSeries = new am4charts.LineSeries();
      lastWeekSeries.dataFields.valueY = `lastWeekConversionRate`;
      lastWeekSeries.dataFields.categoryX = "time";
      lastWeekSeries.stroke = am4core.color("grey");
      lastWeekSeries.strokeWidth = 4;
      lastWeekSeries.fill = am4core.color("grey");
      lastWeekSeries.tooltipText = `Last Week Conversion Rate: {lastWeekConversionRate}% ({lastWeekFullyBooked}% fully booked)`;
      lastWeekSeries.tooltip.background.fill = am4core.color("grey");
      lastWeekSeries.propertyFields.stroke = am4core.color("grey");
      lastWeekSeries.propertyFields.fill = am4core.color("grey");
      lastWeekSeries.fillOpacity = 0.5;
      lastWeekSeries.name = `Last Week Conversion Rate`;
      chart.series.push(lastWeekSeries);

      let series = new am4charts.LineSeries();
      series.dataFields.valueY = `todayConversionRate`;
      series.dataFields.categoryX = "time";
      series.stroke = am4core.color("#47d061");
      series.strokeWidth = 4;
      series.fill = am4core.color("#47d061");
      series.tooltipText = `Conversion Rate: {todayConversionRate}% ({todayFullyBooked}% fully booked)`;
      series.tooltip.background.fill = am4core.color("#47d061");
      series.name = `Today's Conversion Rate`;
      chart.series.push(series);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 20;
    },
    Last7Days: async function () {
      am4core.useTheme(am4themes_material);
      let chart = am4core.create("ConversionRatesChart", am4charts.XYChart);
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "time";
      categoryAxis.renderer.grid.template.location = 0;
      categoryAxis.renderer.minGridDistance = 30;
      categoryAxis.renderer.labels.template.rotation = 300;
      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      let days = Object.keys(this.stats).slice(-7);
      days.forEach((day) => {
        let currentDay = this.stats[day];
        for (const [key, timeData] of Object.entries(currentDay)) {
          const Obj = {};
          let totalCalls = 0;
          let totalBooked = 0;
          Obj.time = `${day} ${key}`;
          for (const [customerId, customerData] of Object.entries(timeData)) {
            for (const [outcome, amount] of Object.entries(customerData)) {
              if (outcome == "Booked") {
                totalBooked += amount;
              }
              totalCalls += amount;
            }
            Obj.conversionRate = ((totalBooked / totalCalls) * 100).toFixed();
          }
          this.chartData.push(Obj);
        }
      });

      chart.data = this.chartData;
      const series = new am4charts.LineSeries();
      series.dataFields.valueY = `conversionRate`;
      series.dataFields.categoryX = "time";
      series.name = `conversionRate`;
      series.stacked = true;
      chart.series.push(series);

      chart.cursor = new am4charts.XYCursor();
      chart.cursor.maxTooltipDistance = 10;
    },
    appendLeadingZeroes(n) {
      if (n <= 9) {
        return "0" + n;
      }
      return n;
    },
  },
  mounted() {
    switch (this.mode) {
      case "today":
        this.Today();
        break;
      case "last7days":
        this.Last7Days();
        break;
      default:
        this.Today();
        break;
    }
  },
};
</script>

<style scoped>
#ConversionRatesChart {
  display: block;
}

.wrapper {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 20fr;
  height: 300px;
}

.title {
  font-size: 1.2em;
  display: flex;
  justify-content: center;
}
</style>
